import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/imgcaptions/aiLogo.png'


const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "mainTop" }
const _hoisted_3 = { class: "topRout" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = {
  key: 0,
  class: "mainCenter"
}
const _hoisted_6 = { class: "mainleft" }
const _hoisted_7 = { class: "mainleftInner" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "mainright" }
const _hoisted_10 = {
  key: 1,
  class: "mainCenter"
}

import { useChatStore } from "@/store/chatStore";
import Chat from "@/mode/Chat";
import ChatMessage from "@/views/chat/ChatMessage.vue";
import Top from "@/components/Top.vue";
import ChatItem from "@/components/ChatItem.vue";
import { computed, nextTick, onMounted, ref, onUnmounted ,watch} from "vue";
import ChatUtils from "@/utils/ChatUtils";
import ChatType from "@/config/ChatType";
// 接口
import ChatroomApi from "@/api/chatGtp/Chatroom"
import ChatgtpItem from "./ChatgtpItem.vue";
import AssistantList from "./AssistantList.vue";
import ChatgtpMessage from "./ChatgtpMessage.vue";
import modelroomApi from "@/api/chatGtp/modelroom";
// 引入路由模块
import routerBox from "@/components/common/routerBox.vue"
// 引入我的模块
import mainBox from "@/components/common/mainBox.vue"
// 引入下拉框
import menuPage from "@/components/common/menuPage.vue";
// 引入页面图标
import { applicationDetail } from "@/views/captions/icon.ts"
// onUnmounted(()=>{
//   assistantShow.value=true
// })

export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  emits: ['closeChile'],
  setup(__props, { emit: __emit }) {

const sentOption=(chatid)=>{
  
  const index = chatGtpUserList.value.findIndex(item=>item.chatId==chatid);
  console.log('位置----------'+index)
    if (index !== -1 && index > 0) { // 元素存在且不在第一位
        const [item] = chatGtpUserList.value.splice(index, 1); // 删除原位置元素
        chatGtpUserList.value.unshift(item); // 插入到数组头部
        actindex.value=0
    }
  // chatGtpUserList
}
const menuShow=ref(false)
// 获取所有模型
const modelList=ref([])
const getModelList=()=>{
  modelroomApi.modelAll().then(res=>{
    console.log(res.data)
    let list=res.data
    list.forEach(item=>{
      let obj={
        value: item.chatModelId,
        label:item.name ,
        children:[]
      }
      item.models.forEach(it=>{
        let one={
          value: it.name,
          label:it.name ,
        }
        obj.children.push(one)
      })
      modelList.value.push(obj)
    })
    console.log(modelList.value)
    chatroomList()
  })
}
// 切换模型
const selOption=(data:any)=>{
  // console.log(data)
  modelroomApi.editRoom(chatIds.value,data[1],data[0]).then(res=>{
    // console.log(res)
    // console.log(modelList.value)
    // let str=chatGtpUserList.value.filter(item=>item.chatId==data[2])[0]
    // console.log(str)
    if(res.code==200){
      chatGtpUserList.value.filter(item=>item.chatId==data[2])[0].model=data[1]
      chatGtpUserList.value.filter(item=>item.chatId==data[2])[0].modelId=data[0]
      nextTick(()=>{
        modelSel.value=JSON.stringify([data[0],data[1]])
      })
      
    }
    
  })
}
const show = ref<boolean>(false);
const assistantShow = ref(true)
const chatGtpUserList = ref([] as any[])
// 查询助手列表
const chatroomList = () => {
  ChatroomApi.QueryChatroom().then(resdata => {
    const chatIdCheck = JSON.parse(localStorage.getItem('chatIdCheck'))
    // console.log(chatGtpUserList.value.findIndex(itom=>itom.chatId==chatIdCheck))
    let indexClick = 0
    chatGtpUserList.value = resdata.rows
    if (chatIdCheck != null && chatGtpUserList.value.length > 0) {
      indexClick = (chatGtpUserList.value.findIndex(itom => itom.chatId == chatIdCheck) > 0 ? chatGtpUserList.value.findIndex(itom => itom.chatId == chatIdCheck) : 0)
    }
    if (resdata.rows.length == 0) {
      chatGtpUserList.value = resdata.rows
      assistantShow.value = true
      return;
    }
    if (resdata.rows.length > 0 && !checkClick.value && !delchatRoom.value) {
      console.log(chatGtpUserList.value)



      if (chatIdCheck == null || chatGtpUserList.value.filter(item => item.chatId == chatIdCheck) == undefined) {
        chatIds.value = resdata.rows[0].chatId
        actindex.value = 0
        nameTxet.value = resdata.rows[0].name
        avatars.value = resdata.rows[0].avatar
        assistantShow.value = false
        let one=chatGtpUserList.value.filter(item=>item.chatId==chatIds.value)[0]
	      modelSel.value=JSON.stringify([one.modelId,one.model])
        console.log('+++++++++')
        console.log( modelSel.value)
        return;
      } else {
        chatIds.value = resdata.rows[indexClick].chatId
        actindex.value = indexClick
        nameTxet.value = resdata.rows[indexClick].name
        avatars.value = resdata.rows[indexClick].avatar
        assistantShow.value = false
        let one=chatGtpUserList.value.filter(item=>item.chatId==chatIds.value)[0]
	      modelSel.value=JSON.stringify([one.modelId,one.model])
        console.log('++++----------+++++')
        console.log( modelSel.value)
        return;
      }

    }
    if (checkClick.value) {
      resdata.rows.forEach((item, index) => {
        if (item.chatId == chatIds.value) {
          actindex.value = index
          nameTxet.value = item.name
          avatars.value = item.avatar
        }
      })
    }
    // 删除聊天室默认选择第一个
    if (delchatRoom.value) {
      delchatRoom.value = false
      chatIds.value = resdata.rows[0].chatId
      actindex.value = 0
      nameTxet.value = resdata.rows[0].name
      avatars.value = resdata.rows[0].avatar
    }
    chatGtpUserList.value = resdata.rows
    show.value = true

    // console.log(chatGtpUserList.value)
  })
}
onMounted(() => {
  
  getModelList()
})
// 返回上一层
const emit = __emit
const handleDown = () => {
  emit('closeChile')
}
const checkClick = ref(false)
const reassistant = (id: string) => {
  checkClick.value = true
  ChatroomApi.AddChatroom(id).then(resdata => {

    // console.log(resdata)
    chatIds.value = resdata.data.chatId
    assistantShow.value = false
    chatroomList()
  })


}
// 添加助手
const addassistant = () => {
  // console.log('添加助手')
  assistantShow.value = true
}
// 刪除聊天
const delchatRoom = ref(false)
const del = (id: string) => {
  // console.log('刪除聊天'+id)
  ChatroomApi.DeleChatroom(id).then(resdata => {
    // chatGtpUserList.value=resdata.rows
    // show.value=true
    // console.log(resdata)
    delchatRoom.value = true
    chatroomList()

  })
}
// 
const chatIds = ref('')
const avatars = ref('')
const actindex = ref(-1)
const nameTxet = ref('')
const modelSel=ref('')
const showThisChat = (index: number, chatId: string, avatar: string, name: string) => {
  assistantShow.value = false
  chatIds.value = chatId
  avatars.value = avatar
  actindex.value = index
  nameTxet.value = name
  let one=''
   one=chatGtpUserList.value.filter(item=>item.chatId==chatId)[0]
   console.log(one)
  modelSel.value=JSON.stringify([one.modelId,one.model])
  
  // 缓存点击数据
  localStorage.setItem('chatIdCheck', JSON.stringify(chatId))
}
const chatStore = useChatStore();
const store = useChatStore();
//   console.log('+++++++++++++++')
//   console.log(chatStore)

const chat = computed((): Chat => {

  return chatStore.chats[chatStore.index];
});
const showChat = (chat: Chat) => {

  store.openChat(chat);
  nextTick(() => {
    ChatUtils.imageLoad("message-box");
  });
};
const delChat = (id: string) => {
  store.delChat(id);
};
onMounted(() => {
  show.value = true;

});

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "",
          class: "logoImg",
          onMousemove: _cache[0] || (_cache[0] = ($event: any) => (menuShow.value=true))
        }, null, 32)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(_toDisplayString(_unref(applicationDetail).chatGtp.name) + " ", 1),
        _createElementVNode("span", null, _toDisplayString(_unref(applicationDetail).chatGtp.version), 1)
      ]),
      _createVNode(mainBox, { class: "topMain" }),
      _withDirectives(_createVNode(menuPage, {
        class: "menuPageStyle",
        onClosemenu: _cache[1] || (_cache[1] = ($event: any) => (menuShow.value=false)),
        onOpenmenu: _cache[2] || (_cache[2] = ($event: any) => (menuShow.value=true)),
        nameInfo: _unref(applicationDetail).chatGtp
      }, null, 8, ["nameInfo"]), [
        [_vShow, menuShow.value]
      ])
    ]),
    (!assistantShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 24 }),
                    _createVNode(_component_el_col, {
                      span: 24,
                      class: "add"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: addassistant,
                          color: "rgba(32,124,246,0.9)",
                          style: {"width":"25.8rem"}
                        }, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createTextVNode("添加助手")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              (show.value)
                ? (_openBlock(), _createBlock(_component_el_scrollbar, {
                    key: 0,
                    class: "list",
                    width: "300px",
                    ref: "scrollbaritem"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chatGtpUserList.value, (assistant, index) => {
                        return (_openBlock(), _createBlock(ChatgtpItem, {
                          key: index,
                          name: assistant.name,
                          id: assistant.chatId,
                          avatar: assistant.avatar,
                          intro: assistant.intro,
                          model: assistant.model,
                          active: actindex.value === index,
                          onDel: del,
                          onClick: ($event: any) => (showThisChat(index, assistant.chatId, assistant.avatar, assistant.name))
                        }, null, 8, ["name", "id", "avatar", "intro", "model", "active", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 512))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (!assistantShow.value)
              ? (_openBlock(), _createBlock(ChatgtpMessage, {
                  key: 0,
                  chatId: chatIds.value,
                  imgavatar: avatars.value,
                  names: nameTxet.value,
                  modelList: modelList.value,
                  onSelOption: selOption,
                  modelSel: modelSel.value,
                  onSentOption: sentOption,
                  class: "mainrightMsg"
                }, null, 8, ["chatId", "imgavatar", "names", "modelList", "modelSel"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (assistantShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(AssistantList, {
            onReassistant: reassistant,
            class: "mainrightlist"
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})